import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      // Top-centre, not Sonner's bottom-right default.
      //
      // The screening wizard, depth selection and account setup all end in a
      // `fixed bottom-0` footer whose actions sit bottom-right (justify-between),
      // so Cancel/Next landed directly under the toast — and Sonner's container
      // is z-index 999999999 against the footers' z-10, so the toast always won.
      // A client could not reach Next while a "Draft saved" toast was showing.
      //
      // Not top-right either: the header is h-16 (64px) with the balance and
      // user menu pushed right, and Sonner's default top offset is 32px, so a
      // toast there covers the profile menu instead. The top centre is the only
      // edge with nothing in it — the header keeps its logo and back button on
      // the left and everything else on the right.
      position="top-center"
      // Below the header on mobile. Under 600px Sonner drops the centred,
      // content-width toast and goes almost full-width (`width: 100%` with
      // 16px side offsets), so "top centre" stops being an empty gap and
      // becomes a bar across the whole header — covering the logo, the back
      // control and the user menu, and swallowing their clicks at z-index
      // 999999999. Caught in review; the desktop case alone was not enough.
      //
      // 80px clears the h-16 (64px) header with 16px to spare. Only the top is
      // set, so Sonner keeps its own defaults for the other three edges.
      mobileOffset={{ top: '80px' }}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
